import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import "./successfull.css";

const Successfull = () => {
  const navigate = useNavigate();
  let Header = localStorage.getItem("Header");
  const OkayClickHandle = () => {
    navigate(Header === "Content Management (Assessment)" ? "/contentMangment" : "/PublishedAssessment")
    if (Header === "Content Management (Assessment)") {
      localStorage.setItem("Header", "Content Management");
    }
  }
  return (
    <div className=" successful_preview_transprant_body ">
      <div className=" p-2 successful_preview_container shadow">
        {/* <img src="/images/Ellipse 208.svg" alt="" /> */}
        <img className="activityLoader" src="/gift/tick_mark.gif" alt="" />
        <span className=" my-4 successfully_message">
          You Have successfully Published Assessment
        </span>
        <button className="successfull_okay_btn" onClick={() => { OkayClickHandle() }}>Okay</button>
      </div>
    </div>
  );
};

export default Successfull;
